import * as React from 'react';

const CircleAddSvg = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' {...props}>
    <path d='M8.046 4.125a.65.65 0 0 1 .65.65v2.578h2.625a.65.65 0 0 1 0 1.3H8.696v2.578a.65.65 0 0 1-1.3 0V8.653H4.79a.65.65 0 0 1-.65-.65.65.65 0 0 1 .65-.65h2.606V4.775a.65.65 0 0 1 .65-.65Z' />
  </svg>
);

export default CircleAddSvg;
